export default "/bundles/assets/attachment_other_b7de11624035575e626367496736373f.png";